module.exports = __webpack_public_path__ + "static/media/presentation_4.0310fffb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons/presentation_4.svg
// module id = 649
// module chunks = 1